import React, { use, useCallback, useEffect, useRef, useState } from "react";
import {
  ClientAccountList,
  ClientContactList,
  ClientsList,
  SpecializationDropdown,
} from "../../../../../redux/Thunk/ClientModule/ClientThunk";
import { useDispatch, useSelector } from "react-redux";
import { Grid, Box, Typography } from "@mui/material";
import {
  generateOrderNumber,
  getmasterDropdownList,
  getProjectDetails,
  saveProject,
  updateProject,
} from "../../../../../redux/Thunk/DashboardModule/DashboardThunk";
import PopupModal from "../../../../../Components/Ui_elements/PopupModal";
import Btn from "../../../../../Components/Ui_elements/Btn";
import Form from "./Form";
import CreateClient from "./CreateClient";
import AccountForm from "../../../../Client/Account/AccountForm";
import { useLocation, useNavigate, useOutletContext, useParams } from "react-router-dom";
import dayjs from "dayjs";
import { validateFields } from "../../../../../Helper/ValidateFields";
import { resetProjectDetail } from "../../../../../redux/Slice/DashboardModule/DashboardSlice";
import { padToFourDigits, padToThreeDigits } from "../../../../../Helper/PadToThreeDigits";
import { FileCopy } from "@mui/icons-material";
import { formatDateTime } from "../../../../../Components/formateDate";

const General = ({}) => {
  const dispatch = useDispatch();
  const { buttonref, setProjectDetail, projectDetail, onSaveRef } = useOutletContext();
  const {
    clients,
    user_manager,
    user_coordinator,
    clientAccount,
    user_QA,
    specialization_list,
    client_contact_list,
  } = useSelector(state => state.root.ClientModule);
  const { project_detail, masterDropdownList } = useSelector(state => state.root.DashboardModule);
  const { user } = useSelector(state => state.root.authUser);
  const { id } = useParams();
  const navigate = useNavigate();
//   const location = useLocation();
// const copiedFromData = location?.state || null;

  const initialState =  {
    client: "",
    pm_name: "",
    order_date: dayjs().format("YYYY-MM-DD HH:mm"), // Set current date
    substitute_pm_name: "",
    account: "",
    project_coordinator: "",
    substitute_project_coordinator: "",
    qa_analyst: "",
    substitute_qa_analyst: "",
    specialization: "",
    due_date: "",
    due_time: "",
    contact_person: "",
  };
  const formFields = [
    { name: "client", label: "Client" },
    { name: "pm_name", label: "Project Manager" },
    { name: "project_coordinator", label: "Project Coordinator" },
    { name: "account", label: "Account" },
    { name: "due_date", label: "Due Date" },
    { name: "due_time", label: "Due Time" },
  ];

  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState(initialState);

  const [isClientSelected, setIsClientSelected] = useState(false);
  const [clientId, setClientId] = useState("");
  const [openContactModal, setOpenContactModal] = useState(false);
  const [openAccountModal, setOpenAccountModal] = useState(false);
  const [abbrevationCode, setAbbrevationCode] = useState({ vCodeRights: "", order_number: "" });
  const [openEmail, setOpenEmail] = useState(false);
  const [openCopyModal, setOpenCopyModal] = useState(false);
  const createClientRef = useRef(null);

  useEffect(() => {
    dispatch(ClientsList());
    // dispatch(UserManager());
    // dispatch(UserCoordinator());
    // dispatch(UserQA());
    dispatch(SpecializationDropdown());
    dispatch(ClientAccountList());
  }, []);

  useEffect(()=>{
    dispatch(ClientContactList(project_detail?.[0]?.client));
  }, [project_detail])
  useEffect(() => {
    dispatch(getmasterDropdownList({ order_id: id }));
  }, [id]);

  useEffect(() => {
    if (id) {
      dispatch(getProjectDetails({ order_id: id }));
    }
  }, [id]);

  useEffect(() => {
    if (id) {
      const projectDetailsData = formData?.order_no;
      setProjectDetail(projectDetailsData);
    }
  }, [formData?.order_no, id]);

  useEffect(() => {    
    if (project_detail[0]) {
      setFormData(prev => ({
        ...prev,
        client: project_detail[0].client,
        pm_name: project_detail[0].project_manager,
        order_date: project_detail[0].order_date,
        substitute_pm_name: project_detail[0].sub_project_manager,
        account: project_detail[0].indirect_customer,
        project_coordinator: project_detail[0].project_coordinator,
        substitute_project_coordinator: project_detail[0].sub_project_coordinator,
        qa_analyst: project_detail[0].QA_specialist,
        substitute_qa_analyst: project_detail[0].substitute_QA,
        specialization: project_detail[0].specialization,
        due_date: (project_detail[0].due_date)?.split(" ")[0],
        due_time: (project_detail[0].due_date)?.split(" ")[1] || "",
        contact_person: project_detail[0].contact,
        order_no: project_detail[0].order_no,
      }));
    }
  }, [project_detail]);

  useEffect(() => {
    return () => {
      setFormData(
        initialState
      );
      dispatch(resetProjectDetail());
    };
  }, []);

  const handleInputChange = e => {
    const { name, value } = e.target;
    if (name === "client") {
      if (value) {
        const data = clients?.find(item => item.iClientId === Number(value));
        setClientId(data?.iClientId);
        dispatch(generateOrderNumber(data?.order_number_prefix)).then(res => {
          if (res?.payload?.status === 200) {
            setAbbrevationCode({
              vCodeRights: data?.order_number_prefix,
              order_number: res?.payload?.data + 1,
            });
            setFormData(prev => ({
              ...prev,
              // order_date: dayjs().format("YYYY-MM-DD HH:mm"),
            }));
            const convertedData = padToFourDigits(res?.payload?.data + 1);

            const projectDetailsData = id
              ? formData?.order_no
              : `${data?.order_number_prefix}${convertedData}`;
            setProjectDetail(projectDetailsData);
          }
        });
        setIsClientSelected(true);
        dispatch(ClientContactList(value));
      } else {
        setIsClientSelected(false);
        setProjectDetail("");
        // Update formData using the spread operator to ensure contact_person is cleared
        setFormData(prev => ({
          ...prev,
          contact_person: "",
          [name]: value,
        }));
        return; // Return early to prevent the second formData update
      }
    }
    setFormData({ ...formData, [name]: value });
    setErrors(prevErrors => ({ ...prevErrors, [name]: "" }));
  };


   const handleSave = () => {
    return new Promise((resolve, reject) => {
      const newErrors = validateFields(formData, formFields);

      if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        reject({ error: "Validation Failed" });
        return;
      }

      if (!id) {
        const prefix = String(abbrevationCode?.vCodeRights ?? "").trim();
        if (!prefix) {
          setErrors(prev => ({
            ...prev,
            client:
              "Order number prefix is still loading. Wait a moment after selecting a client, then save again.",
          }));
          reject({ error: "Order prefix not ready" });
          return;
        }
      }

    let payload = {
      due_date: `${formData?.due_date} ${formData?.due_time}`,
      order_date: formData?.order_date,
      orderPreCode: abbrevationCode?.vCodeRights,
      order_id: id,
      order_no: projectDetail,
      project_createdBy: user?.iUserId,
      project_status: 8, // Need to removed its static not necessary
      specialization: formData?.specialization,
      QA_specialist: formData?.qa_analyst,
      client: formData?.client,
      contact: formData?.contact_person,
      project_manager: formData?.pm_name,
      project_coordinator: formData?.project_coordinator,
      indirect_customer: formData?.account,
      abbrivation: abbrevationCode?.vCodeRights,
      order_number: abbrevationCode?.order_number,
    };

    if (id) {
      payload.sub_pm = formData.substitute_pm;
      payload.sub_pc = formData.substitute_project_coordinator;
      payload.sub_qa = formData.substitute_qa_analyst;

        dispatch(updateProject(payload))
          .then(res => {
            if (res?.payload?.order_data?.order_id) {
              const orderId = res?.payload?.order_data?.order_id;
              navigate(`/general/scoop/${orderId}`);
              resolve({ success: true });
            } else {
              reject({ error: "Update failed" });
            }
          })
          .catch(reject);
      } else {
        dispatch(saveProject(payload))
          .then(res => {
            if (res?.payload?.order_data?.order_id) {
              const orderId = res.payload.order_data.order_id;
              navigate(`/general/scoop/${orderId}`);
              resolve({ success: true });
            } else {
              reject({ error: "Save failed" });
            }
          })
          .catch(reject);
      }
    });
  };

  // --------------- options -----------------
  const clientsOption = clients?.map(i => ({
    label: i.vUserName,
    value: Number(i.iClientId), // or just i.iClientId if it's already a number
  }));

  const usermanagerOptions = masterDropdownList?.userManager?.map(i => ({
    label: i.vUserName,
    value: String(i.iUserId),
    disabled: i.eUserStatus === 4,
  }));
  const coordinatorOptions = masterDropdownList?.userCoordinator?.map(item => ({
    value: String(item.iUserId),
    label: item.vUserName,
    disabled: item.eUserStatus === 4,
  }));
  const accountOptions = clientAccount?.map(i => ({
    value: Number(i.iClientId),
    label: String(i.vUserName),
  }));
  const qaOptions = masterDropdownList?.userQaSpecialist?.map(item => ({
    value: String(item.iUserId),
    label: item.vUserName,
    disabled: item.eUserStatus === 4,
  }));
  const specializationOptions = specialization_list?.map(item => ({
    label: item.name,
    value: String(item.id),
  }));
  const clientContactOptions = client_contact_list?.data?.map(item => ({
    label: `${item.vFirstName + " " + item.vLastName}`,
    value: String(item.iContactId),
  }));  
  const handleCreateClientContact = () => {
    if (createClientRef.current) {
      createClientRef?.current?.click();
      setOpenContactModal(false);
    }
  };

  useEffect(() => {
    if (onSaveRef) {
      onSaveRef(handleSave);
    }
  }, [onSaveRef, handleSave]);
  const handleCopy = () => {
    setOpenCopyModal(true)
    // navigate('/general/createproject'); 
    
  }

  return (
    <>
    {!!id && <Btn startIcon={<FileCopy />}sx={{position:'absolute', m:2, top:0, right:0}} onClick={handleCopy}>Copy</Btn>}
      <Form
        id={id}
        masterDropdownList={masterDropdownList}
        formData={formData}
        abbrevationCode={abbrevationCode}
        errors={errors}
        handleInputChange={handleInputChange}
        clientsOption={clientsOption}
        usermanagerOptions={usermanagerOptions}
        clientContactOptions={clientContactOptions}
        coordinatorOptions={coordinatorOptions}
        isClientSelected={isClientSelected}
        setOpenContactModal={setOpenContactModal}
        setOpenAccountModal={setOpenAccountModal}
        setOpenEmail={setOpenEmail}
        accountOptions={accountOptions}
        qaOptions={qaOptions}
        specializationOptions={specializationOptions}
        handleSave={handleSave}
        projectDetail={projectDetail}
      />

      {openContactModal && (
        <PopupModal
          maxWidth={"md"}
          fullWidth={true}
          open={openContactModal}
          handleClose={() => setOpenContactModal(false)}
          actions={
            <Grid container columnGap={2} justifyContent={"end"}>
              <Btn onClick={handleCreateClientContact}>Add</Btn>
              <Btn onClick={() => setOpenContactModal(false)}>Cancel</Btn>
            </Grid>
          }
          title={<Typography variant="h6">Create Client Contact</Typography>}
        >
          <Box>
            <CreateClient ref={createClientRef} clientId={clientId} />
          </Box>
        </PopupModal>
      )}
      {openCopyModal && (
        <PopupModal
          maxWidth={"sm"}
          fullWidth={true}
          open={openCopyModal}
          handleClose={() => setOpenCopyModal(false)}
          actions={
            <Grid container columnGap={2} justifyContent={"end"}>
              <Btn onClick={() => {navigate('/general/createproject');setOpenCopyModal(false) }}>OK</Btn>
              <Btn onClick={() => setOpenCopyModal(false)}>Cancel</Btn>
            </Grid>
          }
          title={<Typography variant="h6">Copy Project Data</Typography>}
        >
          <Box>
            would you like to copy current project data to new project?
          </Box>
        </PopupModal>
      )}
      {openAccountModal && (
        <PopupModal
          maxWidth={"md"}
          fullWidth={true}
          open={openAccountModal}
          handleClose={() => setOpenAccountModal(false)}
          actions={
            <Grid container columnGap={2} justifyContent={"end"}>
              {/* <Btn>Yes</Btn> */}
              <Btn onClick={() => setOpenAccountModal(false)}>Cancel</Btn>
            </Grid>
          }
          title={<Typography variant="h6">Create Account</Typography>}
        >
          <Box>
            <AccountForm closeForm={() => setOpenAccountModal(false)} />
          </Box>
        </PopupModal>
      )}
      {openEmail && (
        <PopupModal
          maxWidth={"md"}
          fullWidth={true}
          open={openEmail}
          handleClose={() => setOpenEmail(false)}
          actions={
            <Grid container columnGap={2} justifyContent={"end"}>
              {/* <Btn>Yes</Btn> */}
              <Btn onClick={() => setOpenEmail(false)}>Cancel</Btn>
            </Grid>
          }
          title={<Typography variant="h6">Email</Typography>}
        >
          <Box>
            {/* <AccountForm closeForm={() => setOpenAccountModal(false)}/> */}
            future mail component will be here
          </Box>
        </PopupModal>
      )}
    </>
  );
};

export default General;
